import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

/** This directive translates undefined, null, and '' (empty string) to zero.
 *  Useful for non-nullable integer model objects (value must be an integer and not null).
 */
@Directive({
    selector: 'input[lexNullToZero]',
    standalone: false
})
export class NullToZeroDirective {
    constructor(private el: ElementRef, private control: NgControl) { }

    @HostListener('input', ['$event.target'])
    onEvent(target: HTMLInputElement) {
        this.control.viewToModelUpdate(target.value ? target.value : 0);
    }
}
